module.exports = __webpack_public_path__ + "img/icone-03.svg";